import {
  SharedAccountsRepository,
} from '../domain/shared-accounts/repository';
import {
  Access,
  CreateAccessPayload,
} from '../domain/shared-accounts/model';
import HttpClient from '../utils/http-client';
import { Observable } from 'rxjs';
import { Invitation, LinkedCompany, FiscalAlert, OfflineClientPayload } from '../types/accountant';
import { ApiResponse } from '../domain/common/api-response';

export class SharedAccountsRepositoryImplementation extends SharedAccountsRepository {
  private baseUrl = '/sharedaccounts'; // Ajusta según la URL base de tu API
  private httpClient: HttpClient;

  constructor(uid: string, cid: string | null) {
    super();
    this.httpClient = new HttpClient(uid, cid);
  }

  // Accesos
  getAccesses(page: number, limit: number): Observable<ApiResponse<{ data: Access[], total: number }>> {
    return this.httpClient.get(`${this.baseUrl}/access?page=${page}&limit=${limit}`);
  }

  getGrantedAccesses(page: number, limit: number): Observable<ApiResponse<{ data: Access[], total: number }>> {
    return this.httpClient.get(`${this.baseUrl}/access/granted?page=${page}&limit=${limit}`);
  }

  createAccess(access: CreateAccessPayload): Observable<ApiResponse<Access>> {
    return this.httpClient.post(`${this.baseUrl}/access`, {
      email: access.invited_user_email,
      role: access.role,
    });
  }

  deleteAccess(id: number): Observable<ApiResponse<void>> {
    return this.httpClient.delete(`${this.baseUrl}/access/${id}`);
  }

  createCollaborator(payload: { name: string, email: string }): Observable<ApiResponse<Access>> {
    return this.httpClient.post(`${this.baseUrl}/access/cashier`, payload);
  }

  // Accountant Hub specialized methods
  acceptInvitation(id: number): Observable<ApiResponse<void>> {
    return this.httpClient.patch(`${this.baseUrl}/invitation/${id}/accept`, {});
  }

  inviteAccountant(email: string): Observable<ApiResponse<Invitation>> {
    return this.httpClient.post(`${this.baseUrl}/invite`, { email });
  }

  getAccountantInvitations(): Observable<ApiResponse<Invitation[]>> {
    return this.httpClient.get(`${this.baseUrl}/invitations/my`);
  }

  getAccountantLinkedCompanies(): Observable<ApiResponse<{ data: LinkedCompany[], total: number }>> {
    return this.httpClient.get(`${this.baseUrl}/access?role=accountant&status=active`);
  }

  getFiscalAlerts(): Observable<ApiResponse<FiscalAlert[]>> {
    return this.httpClient.get('/accountant/fiscal-alerts');
  }

  healGaps(companyId: number): Observable<ApiResponse<any>> {
    return this.httpClient.post('/accountant/audit/heal-gaps', { company_id: companyId });
  }

  createOfflineClient(payload: OfflineClientPayload): Observable<ApiResponse<Access>> {
    return this.httpClient.post('/accountant/clients', payload);
  }
}
